var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiExtend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_984_8520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_984_8520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51758 14.8232C9.51758 11.3514 9.51758 7.91991 9.51758 4.45963C9.26316 4.45963 9.02005 4.4769 8.78259 4.45387C8.65821 4.44236 8.4999 4.37327 8.44336 4.27539C8.39813 4.20054 8.45467 4.01054 8.52817 3.92418C9.33666 2.99146 10.1621 2.06449 10.9819 1.14329C11.1572 0.947533 11.3042 0.95329 11.4795 1.1548C12.2936 2.07025 13.1077 2.9857 13.9162 3.91842C13.9954 4.00478 14.0406 4.18903 14.001 4.29266C13.9728 4.37902 13.7975 4.44236 13.6844 4.45387C13.4413 4.4769 13.1982 4.45963 12.9381 4.45963C12.9381 7.91991 12.9381 11.3572 12.9381 14.8232C13.1869 14.8232 13.43 14.8059 13.6731 14.829C13.7975 14.8405 13.9558 14.9096 14.0124 15.0074C14.0576 15.0823 14.001 15.2723 13.9275 15.3586C13.1191 16.2914 12.2936 17.2183 11.4738 18.1395C11.2985 18.3353 11.1572 18.3295 10.9763 18.128C10.1621 17.2126 9.34232 16.2971 8.53948 15.3644C8.46032 15.278 8.41509 15.0938 8.45467 14.9902C8.48294 14.9038 8.65821 14.8405 8.77128 14.829C9.00874 14.8059 9.25186 14.8232 9.51758 14.8232ZM13.1247 15.4105C13.0116 15.4047 12.9607 15.3989 12.9099 15.3989C12.3784 15.3874 12.3614 15.3702 12.3614 14.8232C12.3614 11.3629 12.3614 7.89688 12.3614 4.4366C12.3614 4.36175 12.3614 4.28115 12.3614 4.2063C12.3671 3.99903 12.4745 3.88963 12.6781 3.88388C12.8137 3.88388 12.9438 3.88388 13.1417 3.88388C12.4689 3.12964 11.8526 2.43298 11.225 1.7248C10.5918 2.44449 9.97554 3.14115 9.33101 3.87236C9.44408 3.87812 9.49497 3.88388 9.54585 3.88388C10.0773 3.89539 10.0943 3.91266 10.0943 4.45963C10.0943 7.91991 10.0943 11.3859 10.0943 14.8462C10.0943 14.9211 10.0943 15.0017 10.0943 15.0765C10.0886 15.2838 9.98119 15.3932 9.77766 15.3989C9.64197 15.3989 9.51193 15.3989 9.31405 15.3989C9.98119 16.1532 10.5975 16.8498 11.225 17.558C11.8639 16.8383 12.4745 16.1417 13.1247 15.4105Z",
    fill: "url(#paint0_linear_984_8520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98468 5.61114C7.51049 5.61114 8.03629 5.61114 8.56209 5.61114C8.87305 5.61114 8.95786 5.6975 8.95786 6.01992C8.95786 6.51507 8.95786 7.01597 8.95786 7.51112C8.95786 7.81627 8.8674 7.90839 8.5734 7.90839C7.51049 7.90839 6.44757 7.90839 5.38466 7.90839C5.09066 7.90839 5.0002 7.81627 5.0002 7.51112C5.0002 7.00446 5.00586 6.4978 5.0002 5.99113C4.99455 5.72629 5.10762 5.60538 5.37335 5.60538C5.91046 5.61689 6.44757 5.61114 6.98468 5.61114ZM5.59385 6.19265C5.59385 6.56689 5.59385 6.94113 5.59385 7.32112C6.53238 7.32112 7.45395 7.32112 8.37552 7.32112C8.37552 6.93537 8.37552 6.56689 8.37552 6.19265C7.44264 6.19265 6.53238 6.19265 5.59385 6.19265Z",
    fill: "url(#paint1_linear_984_8520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99034 8.4899C7.50483 8.4899 8.02498 8.4899 8.53948 8.4899C8.87871 8.4899 8.95786 8.57051 8.96351 8.90445C8.96351 9.39959 8.96351 9.9005 8.96351 10.3956C8.96351 10.695 8.87305 10.7872 8.5734 10.7872C7.51049 10.7872 6.44757 10.7872 5.38466 10.7872C5.13024 10.7872 5.0002 10.6835 5.00586 10.4129C5.01151 9.89474 5.01151 9.37656 5.00586 8.86414C5.00586 8.5993 5.12458 8.48415 5.38466 8.48415C5.91612 8.49566 6.45323 8.4899 6.99034 8.4899ZM5.58254 10.2056C6.53238 10.2056 7.45395 10.2056 8.38117 10.2056C8.38117 9.81989 8.38117 9.45717 8.38117 9.08869C7.43699 9.08869 6.50976 9.08869 5.58254 9.08869C5.58254 9.46868 5.58254 9.82565 5.58254 10.2056Z",
    fill: "url(#paint2_linear_984_8520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99034 11.3687C7.51614 11.3687 8.04194 11.3687 8.56775 11.3687C8.8674 11.3687 8.95786 11.4608 8.95786 11.7544C8.96351 12.2611 8.96351 12.7678 8.95786 13.2744C8.95786 13.5738 8.8674 13.6659 8.56775 13.6659C7.50483 13.6659 6.44192 13.6659 5.37901 13.6659C5.11893 13.6659 4.99455 13.5565 5.0002 13.2917C5.00586 12.7735 5.00586 12.2553 5.0002 11.7429C5.0002 11.4781 5.11893 11.3629 5.37901 11.3629C5.92177 11.3744 6.45323 11.3687 6.99034 11.3687ZM8.37552 13.0844C8.37552 12.6871 8.37552 12.3187 8.37552 11.9559C7.43133 11.9559 6.51542 11.9559 5.5882 11.9559C5.5882 12.3417 5.5882 12.7044 5.5882 13.0844C6.52673 13.0844 7.44829 13.0844 8.37552 13.0844Z",
    fill: "url(#paint3_linear_984_8520)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_8520",
    x1: 9.51426,
    y1: 1,
    x2: 9.51426,
    y2: 18.2828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D38C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_8520",
    x1: 9.51426,
    y1: 1,
    x2: 9.51426,
    y2: 18.2828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D38C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_8520",
    x1: 9.51426,
    y1: 1,
    x2: 9.51426,
    y2: 18.2828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D38C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_984_8520",
    x1: 9.51426,
    y1: 1,
    x2: 9.51426,
    y2: 18.2828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D38C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiExtend);
export default __webpack_public_path__ + "static/media/gi_extend.404f4823e341138fbdb7af9545988e94.svg";
export { ForwardRef as ReactComponent };